import { http } from "./http.js";
import { vue } from "../main.js";

async function getShippingRouteDates(id) {
  const response = await http.get(`shippings/${id}/route-dates`);
  return response;
}

async function getShipping(id) {
  const response = await http.get(`shippings/${id}`);
  return response;
}

async function getNotes(id) {
  const response = await http.get(`/shippings/${id}/notes`);
  return response.data.map((n) => {
    return {
      id: n.Id,
      text: n.Text,
      date: n.ChangedAt,
      author: n.Author,
    };
  });
}

async function getMessages(id) {
  const response = await http.get(`/shippings/${id}/messages`);
  return response.data.map((n) => {
    return {
      id: n.Id,
      text: n.Text,
      date: n.CreatedAt,
      author: n.Author
        ? {
          id: n.Author.Id,
          title: n.Author.Title,
        }
        : null,
      authorContactPerson: n.AuthorContactPerson
        ? {
          id: n.AuthorContactPerson.Id,
          title: n.AuthorContactPerson.Title,
        }
        : null,
      isReaded: n.IsReaded,
      readedContactPerson: n.ReadedContactPerson
        ? {
          id: n.ReadedContactPerson.Id,
          title: n.ReadedContactPerson.Title,
        }
        : null,
      readedDate: n.ReadedDate,
      source: n.Source,
    };
  });
}

async function acceptToProcess(id) {
  const response = await http.patch("/shippings/accepted-to-process", {
    value: id,
  });
  return response;
}

async function revoke(id) {
  const response = await http.patch("/shippings/revoked", {
    value: id,
  });
  return response;
}

async function cancelByClient(id) {
  const response = await http.patch("/shippings/cancel-by-client", {
    value: id,
  });
  return response;
}

async function restore(id) {
  const response = await http.patch("/shippings/restore", {
    value: id,
  });
  return response;
}

async function changeShippingDirection(id, direction) {
  const response = await http.patch(`shippings/${id}/direction`, {
    value: direction.id,
  });
  return {
    id: response.data.Id,
    title: response.data.Title,
    isRemoved: response.data.IsRemoved,
  };
}

async function getCurrentShippingVersion(id, version) {
  const response = await http.get(`shippings/${id}/versions/${version}`);
  return response.data;
}

async function createSplitShipping(id, reason) {
  const response = await http.patch(`shippings/${id}/splitted`, {
    value: reason,
  });
  return response;
}

async function loadShippingDerrived(id) {
  const response = await http.get(`shippings/${id}/derrived`);
  return response;
}

async function revertShippingSplit(id) {
  const response = await http.post(`shippings/${id}/rpc/revert-splitting`);
  return response;
}

async function createShippingNote(id, note) {
  const response = await http.post(`/shippings/${id}/notes`, {
    text: note,
  });
  return response;
}

async function updateShippingNote(id, noteId, note) {
  const response = await http.put(`/shippings/${id}/notes/${noteId}`, {
    text: note,
  });
  return response;
}

async function deleteShippingNote(id, noteId) {
  const response = await http.delete(`/shippings/${id}/notes/${noteId}`);
  return response;
}

async function addShippingMessage(id, message) {
  const response = await http.post(`/shippings/${id}/messages`, {
    text: message,
  });
  return response;
}

async function getSplittedTree(id) {
  const response = await http.get(`shippings/${id}/splitted-tree`);
  return response;
}

async function getGoodsSummary(id) {
  const response = await http.get(`shippings/${id}/goods-summary`);
  return {
    request: {
      volume: response.data.Request.Volume,
      cargoPlace: response.data.Request.CargoPlace,
      cargoSize: response.data.Request.CargoSize,
      weightBrutto: response.data.Request.WeightBrutto,
      invoiceSum: response.data.Request.InvoiceSum,
      packageType: response.data.Request.PackageType,
    },
    shipping: {
      volume: response.data.Shipping.Volume,
      cargoPlace: response.data.Shipping.CargoPlace,
      cargoSize: response.data.Shipping.CargoSize,
      weightBrutto: response.data.Shipping.WeightBrutto,
      invoiceSum: response.data.Shipping.InvoiceSum,
      packageType: response.data.Shipping.PackageType,
    },
    goodsDetails: {
      volume: response.data.GoodsDetails?.Volume || null,
      cargoPlace: response.data.GoodsDetails?.CargoPlace || null,
      cargoSize: response.data.GoodsDetails?.CargoSize || null,
      weightBrutto: response.data.GoodsDetails?.WeightBrutto || null,
      invoiceSum: response.data.GoodsDetails?.InvoiceSum || null,
      packageType: response.data.GoodsDetails?.PackageType || null,
    },
    routes: response.data.Routes.length
      ? response.data.Routes.map((r) => {
        return {
          title: r.Title,
          value: r.Value
            ? {
              volume: r.Value.Volume,
              cargoPlace: r.Value.CargoPlace,
              cargoSize: r.Value.CargoSize,
              weightBrutto: r.Value.WeightBrutto,
              invoiceSum: r.Value.InvoiceSum,
              packageType: r.Value.PackageType,
            }
            : null,
        };
      })
      : [],
    warehouses: response.data.Warehouses.length
      ? response.data.Warehouses.map((w) => {
        return {
          title: w.Title,
          value: w.Value
            ? {
              volume: w.Value.Volume,
              cargoPlace: w.Value.CargoPlace,
              cargoSize: w.Value.CargoSize,
              weightBrutto: w.Value.WeightBrutto,
              invoiceSum: w.Value.InvoiceSum,
              packageType: w.Value.PackageType,
            }
            : null,
        };
      })
      : [],
    warehouseKiev: {
      accepted: response.data.WarehouseKiev.Accepted
        ? {
          date: response.data.WarehouseKiev.Accepted.Date,
          value: response.data.WarehouseKiev.Accepted.Value
            ? {
              volume: response.data.WarehouseKiev.Accepted.Value.Volume,
              cargoPlace:
                    response.data.WarehouseKiev.Accepted.Value.CargoPlace,
              cargoSize:
                    response.data.WarehouseKiev.Accepted.Value.CargoSize,
              weightBrutto:
                    response.data.WarehouseKiev.Accepted.Value.WeightBrutto,
              invoiceSum:
                    response.data.WarehouseKiev.Accepted.Value.InvoiceSum,
              packageType:
                    response.data.WarehouseKiev.Accepted.Value.PackageType,
            }
            : null,
        }
        : null,
      rest: response.data.WarehouseKiev.Rest.length
        ? response.data.WarehouseKiev.Rest.map((r) => {
          return {
            date: r.Date,
            value: r.Value
              ? {
                volume: r.Value.Volume,
                cargoPlace: r.Value.CargoPlace,
                cargoSize: r.Value.CargoSize,
                weightBrutto: r.Value.WeightBrutto,
                invoiceSum: r.Value.InvoiceSum,
                packageType: r.Value.PackageType,
              }
              : null,
          };
        })
        : [],
    },
  };
}

async function getSameRegionShipping(id) {
  const response = await http.get(`shippings/${id}/same-region-shippings`);
  return response;
}

async function getGoodsDetails(id) {
  const response = await http.get(`shippings/${id}/goods-details`);
  const scale = 3;
  return response.data.map((d) => {
    return {
      id: d.Id,
      trademark: d.Trademark
        ? {
          id: d.Trademark.Id,
          title: d.Trademark.Title,
        }
        : null,
      model: d.Model
        ? {
          id: d.Model.Id,
          title: d.Model.Title,
        }
        : null,
      nomenclature: d.Nomenclature
        ? {
          id: d.Nomenclature.Id,
          title: d.Nomenclature.Title,
        }
        : null,
      article: d.Article
        ? {
          id: d.Article.Id,
          title: d.Article.Title,
        }
        : null,
      material: d.Material,
      site: d.GoodSite,
      country: d.Country
        ? {
          id: d.Country.Id,
          title: d.Country.Title,
        }
        : null,
      category: d.ProductCategory
        ? {
          id: d.ProductCategory.Id,
          title: d.ProductCategory.Title,
        }
        : null,
      unit: d.Unit
        ? {
          id: d.Unit.Id,
          title: d.Unit.Title,
        }
        : null,
      quantity: d.Quantity,
      places: d.Places,
      size: d.Size,
      weigthNetto: vue.$options.filters.separateDigits(
        d.WeightNetto.toFixed(scale).replace(".", ",")
      ),
      weightBrutto: vue.$options.filters.separateDigits(
        d.WeightBrutto.toFixed(scale).replace(".", ",")
      ),
      factoryMarking: d.FactoryMarking,
      fragile: d.Fragile,
    };
  });
}

async function getShippingOutputForm(id) {
  const response = await http.get(`shippings/${id}/output-xlsx`, {
    responseType: "arraybuffer",
  });
  return response.data;
}

async function getShippingStates() {
  const response = await http.get("shipping-states");
  return response.data.map((s) => {
    return {
      id: s.Id,
      title: s.Title,
    };
  });
}

async function getStatesHistory(id) {
  const response = await http.get(`shippings/${id}/states-history`);
  return response.data.map((h) => {
    return {
      id: h.Id,
      createdAt: h.CreatedAt,
      author: h.Author.Title,
      state: h.State.Title,
    };
  });
}

async function changeShippingLabel(id, name, value) {
  const response = await http.patch(`shippings/${id}/lables/${name}`, {
    value,
  });
  return response.data;
}

async function getWarehouse(id) {
  const response = await http.get(`warehouses/${id}`);
  return response.data;
}

async function getCountriesPerPage() {
  const response = await http.get("countries?page=1&pageSize=500");
  return response;
}

async function updateShipping(id, entity) {
  const response = await http.put(`shippings/${id}`, entity);
  return response;
}

async function getWarehouseReferenceAddress(id) {
  const response = await http.get(`warehouses/referencies/addresses/${id}`);
  return response;
}

async function getWarehouseReferenceCountry(entity) {
  const response = await http.get(
    `warehouses/referencies?countryId=${entity}&groupedWarehouse=false`
  );
  return response.data.map((i) => {
    return {
      text: i.Title,
      realId: i.Id,
      type: "warehouse",
    };
  });
}

async function getFactoriesReferenciesCountry(entity) {
  const response = await http.get(`factories/referencies?countryId=${entity}`);
  return response.data.map((i) => {
    return {
      text: i.Title,
      realId: i.Id,
      type: "factory",
    };
  });
}

async function getFactory(id) {
  const response = await http.get(`factories/${id}`);
  return response.data;
}

async function getAddress(id) {
  const response = await http.get(`addresses/referencies/${id}`);
  return response.data;
}

async function getFactoryReference(id) {
  const response = await http.get(`factories/referencies/${id}`);
  return response;
}

async function updateClientsAliases(id, alias) {
  const response = await http.patch(`clients/${id}/aliases`, {
    value: alias,
  });
  return response;
}

async function changeShippingDate(id, dates) {
  const response = await http.patch(`shippings/${id}/dates`, dates);
  return response;
}

async function changeReadyForShipmentPlan(id, date) {
  const response = await http.patch(`shippings/${id}/ready-for-shipment-plan`, {
    value: date,
  });
  return response;
}

async function changeDesiredDeliveryDatePlan(id, date) {
  const response = await http.patch(
    `shippings/${id}/desired-delivery-date-plan`,
    {
      value: date,
    }
  );
  return response;
}

async function getReleaseOrders(id) {
  const response = await http.get(`/release-orders/shippings/${id}`);
  if (response.data) {
    return response.data.map((i) => {
      return {
        id: i.Id,
        author: i.Author,
        releaseOrderPlan: i.ReleaseOrderPlan,
        releaseOrderFact: i.ReleaseOrderFact,
        isPartial: i.IsPartial,
        shippingNumber: i.ShippingNumber,
        client: i.Client,
        sender: i.Sender,
      };
    });
  } else {
    response.data = [];
    return response.data;
  }
}

async function getSenderFactoryLoadingPlace(senderFactoryId, id) {
  const response = await http.get(
    `factories/${senderFactoryId}/loading-places/${id}`
  );
  return response.data;
}

async function getLoadingPersonContact(id) {
  const response = await http.get(`contact-persons/${id}`);
  return response.data;
}

async function getPackageType(id) {
  const response = await http.get(`package-types/${id}`);
  return response.data
    ? {
      packageType: {
        id: response.data.Id,
        title: response.data.Title,
      },
      length: response.data.Length,
      width: response.data.Width,
    }
    : null;
}

async function changeFactoryClosingPlanDate(id, date) {
  const response = await http.patch(`shippings/${id}/factory-closing-plan`, {
    value: date,
  });
  return response;
}

async function markAsReadMessage(shippingId, messageId) {
  const response = await http.patch(
    `shippings/${shippingId}/messages/${messageId}/mark-as-read`
  );
  return response;
}

async function changeReadyForShipmentFact(id, phaseId, date) {
  const response = await http.patch(
    `shippings/${id}/phases/${phaseId}/ready-for-shipment-fact`,
    {
      value: date,
    }
  );
  return response;
}

async function markAllMessagesAsRead(shippingId) {
  const response = await http.patch(
    `shippings/${shippingId}/messages/mark-as-read`
  );
  return response;
}

async function getCategoriesInfo(id) {
  const response = await http.get(
    `shippings/${id}/goods-details/categories-info`
  );
  return response.data.map((i) => {
    return {
      id: i.Id,
      category: i.Category
        ? { id: i.Category.Id, title: i.Category.Title }
        : null,
      volume: i.Volume,
      weightBrutto: i.Weight,
      cargoPlaces: i.CargoPlaces,
    };
  });
}

async function markShippingAsHandled(id) {
  const response = await http.patch(`shippings/${id}/handle`)
  return response;
}

export {
  getShippingRouteDates,
  getShipping,
  getNotes,
  updateClientsAliases,
  changeShippingDate,
  getMessages,
  changeShippingDirection,
  getCurrentShippingVersion,
  createSplitShipping,
  loadShippingDerrived,
  revertShippingSplit,
  createShippingNote,
  updateShippingNote,
  deleteShippingNote,
  addShippingMessage,
  getSplittedTree,
  getGoodsSummary,
  getSameRegionShipping,
  getGoodsDetails,
  getShippingOutputForm,
  getStatesHistory,
  changeShippingLabel,
  getWarehouse,
  getCountriesPerPage,
  updateShipping,
  getWarehouseReferenceAddress,
  getWarehouseReferenceCountry,
  getFactoriesReferenciesCountry,
  getFactory,
  getAddress,
  getFactoryReference,
  getReleaseOrders,
  getSenderFactoryLoadingPlace,
  getLoadingPersonContact,
  getShippingStates,
  acceptToProcess,
  revoke,
  changeReadyForShipmentPlan,
  changeDesiredDeliveryDatePlan,
  cancelByClient,
  restore,
  getPackageType,
  changeFactoryClosingPlanDate,
  markAsReadMessage,
  changeReadyForShipmentFact,
  markAllMessagesAsRead,
  getCategoriesInfo,
  markShippingAsHandled,
};
